// Column header for the Sell Request table. Order must match the cells in
// `ListingRequestRow.vue` and LISTINGS_GRID_TEMPLATE below.
export const LISTINGS_TABLE_COLUMNS = [
  { key: 'property', label: 'Property' },
  { key: 'location', label: 'Location' },
  { key: 'price', label: 'Asking price' },
  { key: 'agreed', label: 'Agreed price' },
  { key: 'status', label: 'Status' },
  { key: 'submitted', label: 'Submitted' },
] as const

// Column widths, shared by the table header and every row. Proportions follow the
// design's 320 / 185 / 185 / 240 / 110 / 40 split; the status column never drops
// below the width of its four-segment bar.
export const LISTINGS_GRID_TEMPLATE =
  'minmax(0, 2.2fr) minmax(0, 1.3fr) minmax(0, 1.3fr) minmax(0, 1.3fr) minmax(172px, 1.6fr) minmax(0, 0.9fr) 40px'
